<template>
  <div class="overview-feedback-chips">
    <div class="overview-feedback-chips-header">
      <feedback-pref-circle class="overview-feedback-circle" :pref-data="prefData" :colors="colors" />
    </div>
    <div class="overview-feedback-chips-content">
      <div
        :key="chipData.type"
      >
        <feedback-pref-chips
          v-if="chipData.data"
          :pref-chips-data="chipData"
          :colors="colors"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FeedbackPrefCircle from '../../common/feedback-modal/FeedbackPrefCircle'
import FeedbackPrefChips from '../../common/feedback-modal/FeedbackPrefChips'
import colors from '../../../scss/_colors.scss'

export default {
  components: {
    FeedbackPrefChips,
    FeedbackPrefCircle
  },
  props: {
    chipData: {
      type: Object,
      default: () => ({})
    },
    prefData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      colors
    }
  }
}
</script>
<style lang="sass">
.overview-feedback-chips
  display: flex
  flex-direction: column
  justify-content: flex-start
  align-items: center
  height: 100%
  width: 100%
.overview-feedback-chips-header
  margin: 2rem 0
.overview-feedback-chips-content
  max-height: 400px
  overflow: auto
.overview-feedback-chips-header .v-progress-circular
  width: 48px !important
  height: 48px !important
.overview-feedback-chips-header .pref-percent h3
  font-size: 24px
  line-height: 1
.overview-feedback-chips-content .chips-container
  justify-content: center
.overview-feedback-chips-content .chips-container:after
   content: none
</style>
